<aside>
  <div class="grid-y sidebar__content">
    <div class="cell shrink">
      <a routerLink="/"><img [src]="logoSrc" data-cy="sidebar-logo" alt="Raven" class="sidebar__logo" /></a>
    </div>

    <nav class="cell" data-cy="main-menu">
      <rav-sidebar-menu [menus]="menus" [isSidebarCollapsed]="isCollapsed"></rav-sidebar-menu>
    </nav>

    <div class="cell sidebar__user-data">
      <ng-content></ng-content>
    </div>

    <img
      class="sidebar__arrow show-for-medium"
      data-cy="sidebar-arrow"
      (click)="collapse()"
      [src]="arrowSrc"
      alt="Collapse"
    />
  </div>
</aside>
